import styled from "styled-components/macro";
import { theme, Sizes } from "ui/theme";

type Align = "left" | "center" | "right";
type Size = keyof Sizes;

type StackProps = {
  /**
   * @type {Align} [$align="initial"] Horizontal alignment of child elements.
   */
  $align?: Align;
  /**
   * @type {Size} [$space="0"] Space beween each child element.
   */
  $space?: Size;
  /**
   * @type {Size} [$topSpace="0"] Space beween top and 1st child element.
   */
  $topSpace?: Size;
};

function getAlignItemsFromEnum(align?: Align) {
  switch (align) {
    case "center":
      return "center";
    case "right":
      return "flex-end";
    case "left":
      return "flex-start";
    default:
      return "initial";
  }
}

/* TODO: Once Safari supports flex gap, enable the row-gap line below and
    then remove child selector and margin
    https://caniuse.com/flexbox-gap */
/* row-gap: ${({ $space }) => ($space ? theme[$space] : 0)}; */
const Stack = styled.div<StackProps>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $align }) => getAlignItemsFromEnum($align)};
  ${({ $topSpace }) => $topSpace && `padding-top:${theme[$topSpace]};`}

  & > :not(:last-child) {
    margin-bottom: ${({ $space }) => ($space ? theme[$space] : 0)};
  }
`;

export default Stack;
